<template>
  <VTest :default-test="defaultTest" :test-diffs="testDiffs" :component="VPrice" i18n="substore" />
</template>

<script>
import VTest from '@/components/Test';
import VPrice from '@/components/Substore/Price';
import defaultTest from './default';
import testDiffs from './diffs';

export default {
  name: 'PriceTest',

  components: {
    VTest,
  },

  data() {
    return {
      defaultTest,
      testDiffs,
      VPrice,
    };
  },
};
</script>
